import { useCallback, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';

export const PorqueElegirnosComponent = ({ t }) => {
    const sliderRef = useRef(null);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    return (
        <div className="container container-slider shadow-default wow slideInLeft">
            <div className='d-flex align-items-center justify-content-between mb-3'>
                <h1 className='title-section mb-0'>{t("whyChooseUs")}</h1>
                <div className="d-flex gap-1">
                    <img className="cursor-pointer" width={40} src={`assets/img/new/arrow-left.svg`} onClick={handlePrev} />
                    <img className="cursor-pointer" width={40} src={`assets/img/new/arrow-right.svg`} onClick={handleNext} />
                </div>
            </div>

            <Swiper
                ref={sliderRef}
                slidesPerView={4}
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                    },
                    400: {
                        slidesPerView: 2,
                    },
                    639: {
                        slidesPerView: 3,
                    },
                    865: {
                        slidesPerView: 4
                    },
                    1000: {
                        slidesPerView: 5
                    },
                    1500: {
                        slidesPerView: 5
                    },
                    1700: {
                        slidesPerView: 5
                    }
                }}
                spaceBetween={15}
                className="mySwiper cards-container"
            >
                <SwiperSlide>
                    <div className="card shadow-default">
                        <img src="assets/img/sections/atencion-cliente.png" alt="Atención al cliente" />
                        <div className="card-overlay">
                            <h3>{t("customerService")}</h3>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="card shadow-default">
                        <img src="assets/img/sections/control-frio.png" alt="Manejo responsable de la cadena de frio" />
                        <div className="card-overlay">
                            <h3>{t("managementCold")}</h3>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="card shadow-default">
                        <img src="assets/img/sections/certificacion-internacional.png" alt="Certificaciones internacionales" />
                        <div className="card-overlay">
                            <h3>{t("internationalCertifications")}</h3>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="card shadow-default">
                        <img src="assets/img/sections/control-fitosanitario.png" alt="Control fitosanitario" />
                        <div className="card-overlay">
                            <h3>{t("phytosanitaryControl")}</h3>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="card shadow-default">
                        <img src="assets/img/sections/calidad-inocuidad.png" alt="Calidad e inocuidad" />
                        <div className="card-overlay">
                            <h3>{t("qualitySafety")}</h3>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="card shadow-default">
                        <img src="assets/img/sections/mercado-internacional.png" alt="Mercado internacional" />
                        <div className="card-overlay">
                            <h3>{t("internationalMarket")}</h3>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    );
}